<template>
  <mb-modal class="mb-share-modal" ref="modal" :title="title" @on-close="state = 'pending'">
    <div v-if="shareChoice" class="p-2">
      <share-choice @choice="onShareChoice" />
    </div>
    <div v-else class="p-2">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a
            href="#"
            @click.prevent="activeTab = 'link'"
            class="nav-link"
            :class="{ active: this.activeTab == 'link' }"
          >
            Copy Link
          </a>
        </li>
        <li class="nav-item">
          <a
            href="#"
            @click.prevent="activeTab = 'email'"
            class="nav-link"
            :class="{ active: this.activeTab == 'email' }"
          >
            Email
          </a>
        </li>
      </ul>
      <div class="container-fluid tab py-2" :class="{ active: this.activeTab == 'link' }">
        <div class="row">
          <div class="col">Copy and paste this link to share via text, whatsapp, facebook..</div>
        </div>
        <div class="row pt-2">
          <div class="col-12 col-sm-8" style="align-self: center">
            <input
              type="text"
              class="form-control"
              style="width: 100%"
              ref="shareURL"
              :value="shareURL"
              readonly
              autofocus
              @click="shareURLClick($event)"
            />
          </div>
          <div class="col-auto mt-2 mt-sm-0">
            <button type="button" class="btn btn-primary sharelink-copy" @click="copyURLClick()" aria-label="Copy">
              Copy
            </button>
          </div>
          <div class="col-auto mt-2" v-if="shareObjectType == 'artist'">
            <i>Sharing this artist will additionally allow uploading songs under this artist.</i>
          </div>
        </div>
      </div>
      <div class="container-fluid tab" :class="{ active: this.activeTab == 'email' }">
        <div class="mb-3 row">
          <label for="email" class="col-12 col-sm-4 col-form-label">Email addresses:</label>
          <div class="col-12 col-sm-7">
            <vue-tags-input
              v-model="email"
              :add-on-key="[',', ' ', 13]"
              placeholder=""
              :tags="emails"
              class="form-control"
              :autocomplete-items="autocompleteEmails"
              @tags-changed="newTags => (emails = newTags)"
            />
            <ErrorList field="email" :errors="errors['email']" />
          </div>
        </div>
        <div class="row">
          <label for="message" class="col-12 col-sm-4 col-form-label">Message:</label>
          <div class="col-12 col-sm-7">
            <textarea class="form-control" v-model="message" rows="5" />
          </div>
        </div>
        <div class="form-group row py-2">
          <div class="offset-sm-4 col-auto">
            <button
              class="btn btn-primary"
              type="button"
              @click="share()"
              :disabled="state != 'pending' || emails.length == 0"
            >
              <span v-if="state == 'sharing'">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Share
              </span>
              <span v-else-if="state == 'sent'">
                <img src="/images/thumbs_up.svg" style="height: 1em; width: 1em; margin-right: 5px" />sent!
              </span>
              <span v-else> Share </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </mb-modal>
</template>

<style scoped>
.tab {
  display: none;
}
.tab.active {
  display: block;
}
</style>
<style>
.vue-tags-input .ti-input {
  border: 0 !important;
}
</style>
<script>
import fetch_csrf from "../utils/csrf"
import ErrorList from "./error_list.vue"
import ShareChoice from "./share_choice.vue"
import MBModal from "./modal.vue"
import bus from "../bus"

export default {
  components: { ErrorList, ShareChoice, "mb-modal": MBModal },
  data() {
    return {
      errors: {},
      message: "",
      email: "",
      emails: [],
      shareURL: null,
      state: "pending",
      shareTitle: "",
      createShareURL: "",
      shareObjectType: "",
      shareChoice: false,
      emailsForAutocomplete: null,
      activeTab: "link",
    }
  },
  methods: {
    reset() {
      this.errors = {}
      this.setMessageDefault()
      this.email = ""
      this.emails = []
      this.shareURL = null
      this.state = "pending"
    },
    validityClass(element) {
      if (this.errors[element]) return "is-invalid"
      else return ""
    },
    async showModal() {
      this.reset()
      if (this.createShareURL) this.getShareLink()

      const r = await fetch("/share/emails.json")
      const data = await r.json()
      this.emailsForAutocomplete = data.map(e => ({ text: e }))
      this.$refs.modal.show()
    },
    getShareLink() {
      this.doShare({ share_type: "link" }).then(r => (this.shareURL = r.url))
    },
    shareURLClick(ev) {
      ev.target.select()
    },
    copyURLClick() {
      this.$refs.shareURL.focus()
      this.$refs.shareURL.select()
      document.execCommand("copy")
    },
    async doShare(data) {
      const r = await fetch_csrf(this.createShareURL, {
        method: "post",
        body: JSON.stringify(data),
        headers: { "Content-type": "application/json" },
      })

      if (!r.ok) {
        if (r.status == 422) {
          const body = await r.json()
          let err = new Error("Validation error:")
          err.body = j
          throw err
        } else throw new Error("HTTP error " + r.status)
      }
      return await r.json()
    },
    async share() {
      this.state = "sharing"

      let postData = {
        share_type: "email",
        email: this.emails.map(e => e.text).join(" "),
        message: this.message,
      }

      try {
        await this.doShare(postData)
        this.state = "sent"
        setTimeout(() => this.$refs.modal.close(), 1500)
      } catch (err) {
        this.state = "pending"
        this.errors = err.body.errors
      }
    },
    setMessageDefault() {
      this.message = `I'm sharing '${this.shareTitle}' with you on via Mixbrite.  Have a listen!`
    },
    onShareChoice(choice) {
      this.shareTitle = choice.label
      this.shareObjectType = choice.objectType
      this.createShareURL = choice.shareURL
      this.shareChoice = false
      this.getShareLink()
    },
  },
  computed: {
    autocompleteEmails() {
      let emails = this.emailsForAutocomplete

      if (emails == null || this.email == null) return []

      return emails.filter(i => {
        return i.text.toLowerCase().indexOf(this.email.toLowerCase()) !== -1
      })
    },
    title() {
      if (this.shareChoice) return "What shall we share?"
      else return `Sharing ${this.shareObjectType}: "${this.shareTitle}"`
    },
  },
  watch: {
    shareTitle: function (title) {
      this.setMessageDefault()
    },
  },
  mounted() {
    bus.on("open-share", info => {
      Object.assign(this, info)
      this.showModal()
    })
  },
}
</script>
